import Button from '@mui/material/Button';
import {useEffect, useState} from "react";
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

{/*   Captcha module documentation:  https://www.npmjs.com/package/react-simple-captcha    */}


export default function ContactForm() {

    let emptyFormObj = {
        name: '',
        phone: '',
        message: '',
        captcha: ''
    }

    const [formData, setFormData] = useState<any>(emptyFormObj)
    // console.log(formData)

    function handleChange(value: string, name: string) {
        // console.log(value, name)
        setFormData((prevState: any) => {
            return {...prevState, [name as keyof typeof prevState]: value.trimStart()}
        })
    }


    async function handleSubmit (event: any) {
        // console.log(event)
        // console.log("Message has been sent")

        const anyEmpty = Array.from(Object.values(formData)).some((item: any) => {
            // Check if the trimmed value is an empty string
            return item.trim() === ""
        })
        // console.log(anyEmpty)

        if (anyEmpty) {
            alert('Please ensure all form fields are filled in.')

        } else {

            if (validateCaptcha(formData.captcha) === true) {
                alert('Captcha Matched. Sending message...');

                // send message to server which then sends email to acepim.com@gmail.com
                // todo: code here....

                let response = await fetch('https://139.162.164.33:5000/api/sendmess', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 'Authorization': 'Bearer ' + String(authTokens.access)
                    },
                    body: JSON.stringify({formData: formData}),
                })
                let data = await response.json()

                if (response.status === 200) {
                    console.log('server responded OK')

                } else {
                    console.log("Smth not OK")
                }


                // clearing the form after message is sent
                setFormData(emptyFormObj)

            } else {
                alert('Captcha does not match. Please, re-enter.');
            }
        }

    }


    useEffect(() => {
        loadCaptchaEnginge(6, "#ffe6e6", "grey", "lower");
    }, []);


    return (

        <div className="form-block">

            <div>
                <div className="form-label">Name, Surname (Title)</div>
                <input
                    name="name"
                    type="text"
                    className="oneline-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    // onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={formData.name}
                />
            </div>

            <div>
                <div className="form-label">Phone and/or Email</div>
                <input
                    name="phone"
                    type="text"
                    className="oneline-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    // onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={formData.phone}
                />
            </div>

            <div className="item-merged">
                <div className="form-label">Message</div>
                <textarea
                    name="message"
                    // rows={4}
                    className="message-textfield"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    // onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={formData.message}
                />
            </div>


            <div className="item-merged captcha-button-col">

                <div><LoadCanvasTemplate /></div>       {/*  CAPTCHA  */}

                <div className="captcha-input">
                    <div>Captcha:</div>
                    <input
                        name="captcha"
                        type="text"
                        className="oneline-input"
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        value={formData.captcha}
                    />
                </div>

                <div className="message-button">
                    <Button
                        variant="contained"
                        // onClick={(handleSendMessage) => {alert('clicked')}}
                        onClick={(event: any) => handleSubmit(event)}
                        sx={{backgroundColor: "#cc7a00", width: "150px", height: "30px"}}>
                        SEND
                    </Button>
                </div>

            </div>

        </div>

    )
}

